/**
 * SDK event formatter - Version Router
 * Routes to appropriate SDK version formatter based on SDK version
 */

import * as formatter_2_1_3 from './sdk-format-2.1.3.js';
import * as formatter_2_1_5 from './sdk-format-2.1.5.js';

// SDK version to formatter mapping
const formatters = {
  '2.1.3': formatter_2_1_3,
  '2.1.4': formatter_2_1_3, // 2.1.4 uses same format as 2.1.3
  '2.1.5': formatter_2_1_5,
};

/**
 * Format normalized event for SDK consumption
 * @param {object} normalizedEvent - Normalized event from parser
 * @param {string} sdkVersion - SDK version (e.g., '2.1.3', '2.1.5')
 * @returns {object} SDK-formatted event
 */
function formatForSDK(normalizedEvent, sdkVersion = '2.1.5') {
  // Default to latest version if not specified or unknown
  const version = sdkVersion || '2.1.5';
  const formatter = formatters[version] || formatters['2.1.5'];
  
  return formatter.formatForSDK(normalizedEvent);
}

/**
 * Format user object for SDK (delegates to version-specific formatter)
 * @param {object} user - Normalized user
 * @param {string} platform - Platform name
 * @param {string} sdkVersion - SDK version
 * @returns {object} SDK user format
 */
function formatUser(user, platform, sdkVersion = '2.1.5') {
  const version = sdkVersion || '2.1.5';
  const formatter = formatters[version] || formatters['2.1.5'];
  
  return formatter.formatUser(user, platform);
}

/**
 * Get emoji for gift name (only available in 2.1.5+)
 * @param {string} giftName - Gift name
 * @returns {string} Emoji
 */
function getGiftEmoji(giftName) {
  return formatter_2_1_5.getGiftEmoji(giftName);
}

export { formatForSDK, formatUser, getGiftEmoji };
